import { calcDeduzioneNottePassiva } from '../components/Turni/nottePassiva';

const ABSENCE_TYPES = ['ferie', 'permesso', 'malattia', 'infortunio'];

export const calcDuration = (start_time, end_time) => {
  if (!start_time || !end_time) return 0;
  const [sH, sM] = start_time.split(':').map(Number);
  const [eH, eM] = end_time.split(':').map(Number);
  let d = (eH + eM / 60) - (sH + sM / 60);
  if (eH === 23 && eM >= 58 && sH !== 23) d += 24 - (eH + eM / 60);
  if (d < 0) d += 24;
  return d;
};

const supplementDay = (lv, monthShifts, allDates, dailyOre, acc) => {
  const leaveType = (lv.leave_type || '').toLowerCase();
  const leaveDur = calcDuration(lv.start_time, lv.end_time);
  const hrsPerDay = leaveType === 'permesso'
    ? (leaveDur > 0 ? leaveDur : dailyOre)
    : (leaveDur > 1 ? leaveDur : dailyOre);
  allDates.forEach(d => {
    if (d < lv.start_date || d > lv.end_date) return;
    const hasShift = monthShifts.some(t => t.date === d && ABSENCE_TYPES.includes(t.shift_type));
    if (hasShift) return;
    if (leaveType === 'ferie') acc.ferieHours += hrsPerDay;
    else if (leaveType === 'permesso') acc.permessiHours += hrsPerDay;
    else if (leaveType === 'malattia') acc.malattiaHours += hrsPerDay;
    else if (leaveType === 'infortunio') acc.infortunioHours += hrsPerDay;
  });
};

const supplementFromLeaves = (managerFerieList, monthShifts, allDates, uName, dailyOre) => {
  const acc = { ferieHours: 0, permessiHours: 0, malattiaHours: 0, infortunioHours: 0 };
  (managerFerieList || [])
    .filter(lv => lv.operator_name === uName && lv.status === 'approvata')
    .forEach(lv => supplementDay(lv, monthShifts, allDates, dailyOre, acc));
  return acc;
};

export const calcMonthlyStats = (allDays, turniData, managerFerieList, user, reperibilitaData = []) => {
  const uName = `${user.nome} ${user.cognome}`.trim();
  const allDates = allDays.map(d => d.fullDate);
  const monthShifts = turniData.filter(t => t.operator_name === uName && allDates.includes(t.date));
  const dailyOre = parseFloat(user.ore_giornaliere_previste || 0);

  let expectedHours = 0, workedHours = 0, overtimeHours = 0;
  let ferieHours = 0, permessiHours = 0, malattiaHours = 0, infortunioHours = 0;

  monthShifts.forEach(t => {
    const dur = calcDuration(t.start_time, t.end_time);
    if (t.shift_type === 'ferie') {
      ferieHours += dur > 1 ? dur : dailyOre;
    } else if (t.shift_type === 'permesso') {
      permessiHours += dur > 0 ? dur : dailyOre;
    } else if (t.shift_type === 'malattia') {
      malattiaHours += dur > 1 ? dur : dailyOre;
    } else if (t.shift_type === 'infortunio') {
      infortunioHours += dur > 1 ? dur : dailyOre;
    } else {
      const counted = dur - calcDeduzioneNottePassiva(t);
      expectedHours += counted;
      if (t.status === 'timbrato') workedHours += counted;
      if (parseInt(t.is_overtime, 10) === 1) overtimeHours += counted;
    }
  });

  const supp = supplementFromLeaves(managerFerieList, monthShifts, allDates, uName, dailyOre);
  ferieHours += supp.ferieHours;
  permessiHours += supp.permessiHours;
  malattiaHours += supp.malattiaHours;
  infortunioHours += supp.infortunioHours;

  const reperibilitaHours = (reperibilitaData || [])
    .filter(r => r.operator_name === uName && allDates.includes(r.date))
    .reduce((acc, r) => acc + calcDuration(r.start_time, r.end_time), 0);

  const fmt = v => +Number(v).toFixed(1);
  return {
    uName,
    oreMensiliContratto: parseFloat(user.ore_mensili_previste || 0),
    expectedHours: fmt(expectedHours),
    workedHours: fmt(workedHours),
    ferieHours: fmt(ferieHours),
    permessiHours: fmt(permessiHours),
    malattiaHours: fmt(malattiaHours),
    infortunioHours: fmt(infortunioHours),
    overtimeHours: fmt(overtimeHours),
    reperibilitaHours: fmt(reperibilitaHours),
  };
};
